import React, { Component } from 'react';
import cx from 'classnames';
import Moment from 'moment';
import { connect } from 'react-redux';

import CalendarUIModel from '../../../api-wrapper/ui-models/calendar';

import { getCMSUrl } from '../../constants/cms-urls';
import TranslatedCopy from '../../intl/translated-copy';

import BookerCalendarPicker from '../booker/booker-calendar-picker';
import BookerFormField from '../booker/booker-form-field';
import BookerPassengerSelector from '../booker/booker-passenger-selector';
import BookerTripSwitch from '../booker/booker-trip-switch';
import CubaDestinationModal from '../booker/cuba-destination-modal';
import DatePickerNewGrid from '../booker/date-picker-newgrid';
import FlightBookerRouteSelectorFull from '../booker/flight-booker-route-selector';

import airportCodes from '../../constants/airport-codes';
import defaultPassengersMap from '../../constants/booker-passengers-maps';
import { HERTZ_FORMAT } from '../../constants/date-time-formats';
import tripTypesEnum from '../../constants/trip-types-enum';
import passengerShortcodes from '../../constants/passenger-shortcodes';

import * as BookerActions from '../../../redux/actions/booking/booker-action-creators';


const DEPARTURE = 0;
const RETURNING = 1;

const mapStateToProps = state => ({
  destinationAirport: state.Booker.destinationAirport,
  formValues: state.form['HEADER_MENU_QUICKBOOKER'],
  originAirport: state.Booker.originAirport,
  storefront: state.Manage.storefront,
  tripType: state.Booker.tripType,
  passengersData: state.Booker.passengersData,
});

class HeaderMenuQuickbooker extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentLeg: DEPARTURE,
      destinationFocus: false,
      isDatePickerActive: false,
      itinerary: [null, null],
      passengerSelectFocus: false,
      originAirport: null,
      origenFocus: false,
      showCalendar: true,
      showFormError: false,
      habanaModal: false,
    };

    this.handleClick = this.handleClick.bind(this);
    this.handleCalendarPickerClick = this.handleCalendarPickerClick.bind(this);
    this.handleFocusFullQuickbookerPassenger = this.handleFocusFullQuickbookerPassenger.bind(this);
    this.handleItinerarySelection = this.handleItinerarySelection.bind(this);
  }

  componentDidMount() {
    const { dispatch, storefront } = this.props;

    Moment.locale(storefront);
    dispatch(BookerActions.changeTripType(tripTypesEnum.ROUND_TRIP));
  }

  render() {
    const {
      bookMenuType,
      className,
      country,
      dispatch,
      language,
      passengersData,
      storefront,
      tripType,
    } = this.props;

    const {
      currentLeg,
      isDatePickerActive,
      itinerary,
      habanaModal,
      passengerSelectFocus,
      showCalendar,
    } = this.state;

    const bookClasses = cx(
      {
        HeaderMenuBook: true,
        'is-active': true,
      },
      `HeaderMenuBook--${bookMenuType}`,
      className
    );

    const quickBookerRouteClasses = cx({
      'FlightBookerRouteItem': true,
      'FlightBookerRouteQuickbooker': true,
      'FlightBookerRouteBookerMain': true,
    });

    const quickBookerPassengerRouteClasses = cx({
      'FlightBookerRouteItem': true,
      'FlightBookerRouteQuickbooker': true,
      'FlightBookerRouteBookerMain': true,
      'FlightBookerRouteItem-active': passengerSelectFocus,
    });

    return (
      <div className={ bookClasses } style={ bookMenuType }>
        <div className='HeaderMenuBook-quickBooker'>
          <div className='Quickbooker-wrapper HeaderMenuQuickbooker'>
            <div className='FlightQuickbooker-header'>
              <BookerFormField className='FlightBooker-top' layoutCols={ true }>
                <BookerTripSwitch
                  country={ country }
                  dispatch={ dispatch }
                  goToBookpage={ true }
                  language={ language }
                  storefront={ storefront }
                  tripType={ tripType }
                />
              </BookerFormField>
              { habanaModal &&
                <CubaDestinationModal
                  close={ this.handleCloseModalHabana }
                  redirFlightBookerSubmit={ this.handleRedirectHabana } />
              }

              {/* sección de cupón */ }
              <div className='QuickBookerCoupon-wrapper'>
                <TranslatedCopy
                  className='QuickBookerCoupon-text u-textSmall'
                  copyID='QUICKBOOKER_GO_ADVANCED_SEARCH'
                  tagName='p' />
                <a
                  className='QuickBookerFooterCoupon-link Link u-textLowercase'
                  href={ getCMSUrl(country, language, 'BOOK') }>
                  <TranslatedCopy copyID='APP_ADVANCED_SEARCH' />
                </a>
              </div>
            </div>

            {/* body del quickbooker */ }
            <div className='HeaderMenuQuickbooker-FlightRoute'>
              <div className='Airport-container'>
                <FlightBookerRouteSelectorFull
                  dispatch={ dispatch }
                />
              </div>

              {/* calendario */ }
              <div className={ isDatePickerActive ? quickBookerRouteClasses + ' FlightBookerRouteItem-datepicker FlightBookerRouteItem-active' : quickBookerRouteClasses + ' FlightBookerRouteItem-datepicker' }>
                { showCalendar && (
                  <BookerFormField labelCopyID='BREADCRUMB_DATES' >
                    <BookerCalendarPicker
                      itinerary={ itinerary }
                      onClick={ this.handleCalendarPickerClick }
                      isDatePickerActive={ isDatePickerActive }
                      isQuickBooker={ true }
                      isHeaderQuickBooker={ true }
                      singleDate={ tripType === 'ONE_WAY' }
                      storefront={ storefront }
                      isBooking={ true } />
                    <DatePickerNewGrid
                      buttonClick={ this.handleCalendarPickerClick }
                      calendarModel={ CalendarUIModel.create(Moment(), true) }
                      currentLeg={ currentLeg }
                      handleItinerarySelection={ this.handleItinerarySelection }
                      isDatePickerActive={ isDatePickerActive }
                      isPopupInline={ false }
                      popupType={ '-hertz' }
                      isQuickBooker={ true }
                      itinerary={ itinerary }
                      popupPosition={ 'left' }
                      storefront={ storefront } />
                  </BookerFormField>
                ) }
              </div>

              {/* tipos de pasajero*/ }
              <div className={ quickBookerPassengerRouteClasses + ' FlightBookerRouteItem-passengers' }>
                { showCalendar && (
                  <BookerFormField labelCopyID='PRESELECT_ONLY_PASSENGERS'>
                    <BookerPassengerSelector
                      dispatch={ dispatch }
                      handleFocusFullQuickbookerPassenger={ this.handleFocusFullQuickbookerPassenger }
                      passengersData={ passengersData }
                      passengersMap={ defaultPassengersMap.defaultPassengersMap }
                      ref='quick-booker' />
                  </BookerFormField>
                ) }
              </div>

              {/* botón submit */ }
              <div className='FlightBookerRoute-submit'>
                { this.renderSubmitButton() }
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }


  renderSubmitButton() {
    const {
      destinationAirport,
      originAirport,
      tripType,
    } = this.props;

    const { itinerary } = this.state;

    let disabledButton = true;
    let submitButton = '';

    const isDateSelected = (tripType === tripTypesEnum.ROUND_TRIP) ? itinerary[0] && itinerary[1] ? true : false :
      (tripType === tripTypesEnum.ONE_WAY) ? itinerary[0] ? true : false : null;

    if (originAirport.code && destinationAirport.code && isDateSelected) {
      disabledButton = false;
    }

    submitButton = (
      <button type='button'
        className='submit-btn'
        disabled={ disabledButton ? 'disabled' : false }
        onClick={ !disabledButton ? this.handleClick : null }>
        <span className='Icon Icon--arrowRight'></span>
      </button>
    );

    return submitButton;
  }

  handleOpenModalHabana = () => {
    const htmlTag = document.getElementsByTagName('html')[0];
    if (window.scrollY !== 0) {
      localStorage.setItem('position', window.scrollY);
    }
    htmlTag.classList.add('Modal-open--state');
    this.setState({ habanaModal: true });
  }

  handleCloseModalHabana = () => {
    const { habanaModal } = this.state;
    const htmlTag = document.getElementsByTagName('html')[0];

    htmlTag.classList.remove('Modal-open--state');
    if (localStorage.hasOwnProperty('position')) {
      const position = localStorage.getItem('position');
      window.scrollTo(0, position);
    }

    if (habanaModal) {
      this.setState({ habanaModal: false });
    }
  }

  handleRedirectHabana = (cuba) => {
    const {
      country,
      destinationAirport,
      language,
    } = this.props;

    const query = this.flightBookerSubmit(query);
    const locationBookE4 = getCMSUrl(country, language, 'BOOK_FLIGHT_OPTIONS');
    let isCuba = 'false';

    if (destinationAirport && airportCodes && destinationAirport.code === airportCodes.HAV && cuba === 'isCuba') {
      isCuba = 'true';
    }

    window.location.replace(`${locationBookE4}?itinerary=${query.itinerary}&leg=1&travelers=${query.travelers}&cuba=${isCuba}`);
  }

  handleClick = (e) => {
    e.preventDefault();

    const {
      country,
      destinationAirport,
      isActiveFlowCorporate,
      language,
    } = this.props;

    if (destinationAirport.code === airportCodes.HAV) {
      this.handleOpenModalHabana();
    } else {
      const query = this.flightBookerSubmit(query);
      const locationBookE4 = getCMSUrl(country, language, 'BOOK_FLIGHT_OPTIONS');
      window.location.replace(`${locationBookE4}?itinerary=${query.itinerary}&leg=1&travelers=${query.travelers}&corporate=${isActiveFlowCorporate}`);
    }
  }

  handleFocusFullQuickbookerPassenger(value) {
    this.setState({
      passengerSelectFocus: value,
    });
  }

  handleCalendarPickerClick() {
    const { isDatePickerActive } = this.state;

    this.setState({
      isDatePickerActive: !isDatePickerActive,
    });
  }

  handleItinerarySelection(itinerary) {
    const { currentLeg } = this.state;
    const { tripType } = this.props;
    const datePickerActive = false;
    let newLeg = 0;
    if (tripType === 'ROUND_TRIP') {
      newLeg = currentLeg === DEPARTURE ? RETURNING : DEPARTURE;
    }

    if (currentLeg === RETURNING) {
      this.handleCalendarPickerClick();
    }
    const objCalendarType = {};
    if (tripType !== 'ROUND_TRIP') {
      objCalendarType.isDatePickerActive = datePickerActive;
      this.handleCalendarPickerClick();
    }
    objCalendarType.currentLeg = newLeg;
    objCalendarType.itinerary = itinerary;

    this.setState(objCalendarType);
  }

  /* helpers */

  flightBookerSubmit() {
    const {
      destinationAirport,
      originAirport,
      passengersData,
      tripType,
    } = this.props;

    const { itinerary } = this.state;
    const query = {};

    if (originAirport && destinationAirport) {
      const departingDate = this.granPlanDateFormatter(itinerary[0]);
      const departingCode = `${originAirport.code}_${destinationAirport.code}`;

      if (tripType === tripTypesEnum.ONE_WAY) {
        query.itinerary = `${departingCode}`;
        if (departingDate !== '') {
          query.itinerary += `_${departingDate}`;
        }
      }

      if (tripType === tripTypesEnum.ROUND_TRIP) {
        const returningDate = this.granPlanDateFormatter(itinerary[1]);
        const returningCode = `${destinationAirport.code}_${originAirport.code}`;

        if (departingDate !== '' && returningDate !== '') {
          query.itinerary = `${departingCode}_${departingDate}.${returningCode}_${returningDate}`;
        } else {
          query.itinerary = `${departingCode}.${returningCode}`;
        }
      }
    }

    query.leg = 1;

    query.travelers = `${passengerShortcodes.ADULT}${passengersData.ADULT}_`;
    query.travelers += `${passengerShortcodes.CHILD}${passengersData.CHILD}_`;
    query.travelers += `${passengerShortcodes.INFANT}${passengersData.INFANT}_`;
    query.travelers += `${passengerShortcodes.PETS_IN_HOLD}0_`;
    query.travelers += `${passengerShortcodes.PETS_IN_CABIN}0`;

    return query;
  }

  granPlanDateFormatter(itineraryDate) {
    return itineraryDate ? itineraryDate.format(HERTZ_FORMAT) : '';
  }
}

HeaderMenuQuickbooker = connect(mapStateToProps)(HeaderMenuQuickbooker);

export default HeaderMenuQuickbooker;
